import type { TrackConversionEventParams } from "@circle-react/api/conversionTrackingApi";
import { amount } from "@circle-react/helpers/paywalls/currencies";
import { v4 as uuidv4 } from "uuid";

export const buildMetaFunnelEvent = (
  params: TrackConversionEventParams,
  pixelId?: string,
) => ({
  eventName: params.eventName,
  dedupKey: params.funnelUuid?.trim()
    ? params.eventName === "add_payment_info" && params.fireNonce
      ? `${params.funnelUuid}:${params.fireNonce}`
      : params.funnelUuid
    : (params.fireNonce ?? uuidv4()),
  pixelId,
  value:
    params.value !== undefined && params.currencySmallestUnit
      ? amount({ smallest_unit: params.currencySmallestUnit }, params.value)
      : undefined,
  currency: params.currency?.toUpperCase(),
  paymentType: params.paymentType,
});
